'use client';

import Link from 'next/link';
import { useI18n, interpolate } from '@/lib/i18n/context';

export function Footer() {
  const { t } = useI18n();
  const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';

  const FOOTER_LINKS = {
    [t.footer.sections.explore]: [
      { label: t.footer.links.home, href: '/' },
      { label: t.footer.links.hotgirl, href: '/hashtag/Xiuren' },
      { label: t.footer.links.coser, href: '/hashtag/YiTuYu' },
      { label: t.footer.links.model, href: '/hashtag/IESS' },
      { label: t.footer.links.aoDai, href: '/hashtag/AoDai' },
    ],
    [t.footer.sections.account]: [
      { label: t.footer.links.login, href: '/login' },
      { label: t.footer.links.register, href: '/register' },
      { label: t.footer.links.upload, href: '/upload' },
      { label: t.footer.links.dashboard, href: '/dashboard' },
    ],
    [t.footer.sections.support]: [
      { label: t.footer.links.terms, href: '/terms-of-service' },
      { label: t.footer.links.privacy, href: '/privacy-policy' },
      { label: "About Us", href: '/about' },
      { label: t.footer.links.contact, href: '/contact' },
    ],
  };

  return (
    <footer className="border-t border-white/5 mt-16 py-12 px-4">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div>
            <Link href="/" className="text-2xl font-display font-bold gradient-text block mb-3">
              {appName}
            </Link>
            <p className="text-gray-600 text-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          {/* Links */}
          {Object.entries(FOOTER_LINKS).map(([section, links]) => (
            <div key={section}>
              <h4 className="text-white text-sm font-semibold mb-4">{section}</h4>
              <ul className="space-y-2.5">
                {links.map(({ label, href }) => (
                  <li key={href}>
                    <Link href={href} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-sm">
            {interpolate(t.footer.copyright, { year: new Date().getFullYear() })}
          </p>
          <div className="flex items-center gap-4">
            {[
              { label: 'Facebook', icon: 'F', href: `https://facebook.com/${appName}` },
              { label: 'TikTok', icon: 'T', href: `https://tiktok.com/@${appName}` },
            ].map(({ label, icon, href }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer"
                className="w-8 h-8 rounded-lg bg-surface-800 hover:bg-brand-600 flex items-center justify-center text-gray-400 hover:text-white transition-all text-xs font-bold"
                aria-label={label}>
                {icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
